import { h, type PropType, defineComponent, computed } from 'vue'

import {
  type StyleProviderProps,
  type ConfigProviderProps,
  ConfigProvider,
  StyleProvider,
  legacyLogicalPropertiesTransformer,
} from 'ant-design-vue'

import { type ThemeConfig } from 'ant-design-vue/es/config-provider/context'
import { themeConfig } from '../../constants/theme'

export const AntProvider = defineComponent({
  props: {
    styleProviderProps: {
      type: Object as PropType<StyleProviderProps>,
    },
    configProviderProps: {
      type: Object as PropType<ConfigProviderProps>,
    },
    theme: {
      type: String as PropType<'light' | 'dark'>,
      default: 'light',
      required: true,
    },
  },
  setup(props, { slots }) {
    const antTheme = computed<ThemeConfig>(() => {
      return themeConfig[props.theme]
    })

    return () => {
      return h(
        StyleProvider,
        {
          transformers: [legacyLogicalPropertiesTransformer],
          ...props.styleProviderProps,
        },
        () => [
          h(
            ConfigProvider,
            {
              ...props.configProviderProps,
              theme: {
                hashed: false,
                ...antTheme.value,
              },
            },
            () => [slots.default?.()]
          ),
        ]
      )
    }
  },
})
